<template>
  <div v-loading="auditLoading">
    <header class="yxtbiz-trainPlanAudit_title">{{$t("pc_biz_o2o_change_points" /* 改动点 */)}}</header>
    <yxt-table
      class="mt24 width-percent-100"
      :data="tableData">
      <yxt-table-column
        prop="title"
        show-overflow-tooltip
        :label="$t('pc_biz_o2o_content' /* 内容 */)"
        width="180">
      </yxt-table-column>
      <yxt-table-column
        v-for="{label,prop} in columnList"
        :key="prop"
        show-overflow-tooltip
        :label="label">
        <template slot-scope="{row}">
          <template v-if="row.type == 1 && row[prop] != '--'">
           <div v-for="(attach, index) of row[prop]" :key="index">
             <yxtbiz-attachment-check 
                             :data="attach"
                             :mode="'text'"
                             :need-download="true"
                             :need-delete="false"
                             @download="downfile">
            </yxtbiz-attachment-check>
            </div>
          </template>
          <yxt-image :src="row[prop]" v-else-if="row.type == 2 && row[prop] != '--'" :preview-src-list="[row[prop]]"  class="yxtbiz-trainPlanAudit_imageClass"></yxt-image>
          <span v-else>{{row[prop]}}</span>
        </template>
      </yxt-table-column>
    </yxt-table>
     <yxt-button type="text" class="mt24" @click="viewDetail">{{$t('pc_biz_o2o_view_full_plandetail' /* 查看完整计划详情 */)}}</yxt-button>
     <PlanDetail ref="plandetailDialog"/>
  </div>
</template>

<script>
import { getPlanAuditCompare, putThirdUrl} from '../service';
import PlanDetail from './components/plan-detail.vue';

export default {
  name: 'YxtbizO2oTrainplanAudit',
  name_zh: '培训计划审核信息',
  components: {PlanDetail},
  props: {
    formId: {
      type: String,
      required: true,
      desc: '表单id',
      setter: 'StringSetter'
    }
  },
  data() {
    return {
      auditLoading: false,
      tableData: [],
      columnList: [{
        label: this.$t('pc_biz_o2o_operate_before' /* 操作前 */),
        prop: 'before'
      }, {
        label: this.$t('pc_biz_o2o_operate_after' /* 操作后 */),
        prop: 'after'
      }]
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      this.auditLoading = true;
      getPlanAuditCompare(this.formId).then(data=>{
        this.tableData = data || [];
        this.tableData = this.tableData.map(ele=>{
          if (ele.type === 1) {
            if (ele.before !== '--') {
              ele.before = JSON.parse(ele.before) || '--';
            }
            if (ele.after !== '--') {
              ele.after = JSON.parse(ele.after) || '--';
            }
          }
          return ele;
        });
      }).finally(()=>{
        this.auditLoading = false;
      });
    },
    viewDetail() {
      this.$refs.plandetailDialog.init(this.formId);
    },
    downfile(fileId) {
      putThirdUrl(fileId).then(res => {
        window.location.href = res;
      });
    }
  }
};
</script>